<template>
  <div class="c-icon" :class="`c-icon_${icon} ${colorLocal ? `c-icon_color_${colorLocal}` : ''}`">
    <div class="c-icon__wrapper">
      <img v-if="icon === 'calendar'" :src="calendarIcon" alt="" />
      <img v-if="icon === 'link'" :src="linkIcon" alt="" />

      <svg
        v-if="icon === 'conversation'"
        width="15"
        height="14"
        viewBox="0 0 15 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5 3.98155V2.01845C5 1.45671 5.44844 1 6 1H13C13.5516 1 14 1.45671 14 2.01845V5.98155C14 6.54329 13.5516 7 13 7H11M9 4H2C1.44844 4 1 4.45671 1 5.01845V8.98155C1 9.54329 1.44844 10 2 10H4V13L7 10H9C9.55156 10 10 9.54329 10 8.98155V5.01845C10 4.45671 9.55156 4 9 4Z"
          stroke="#8E9CBB"
          stroke-width="2"
          stroke-linejoin="round"
        />
      </svg>

      <svg
        v-if="icon === 'edit'"
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.33943 1.62805L8.63232 0.920947L8.63232 0.920948L9.33943 1.62805ZM10.8557 1V0V1ZM13 3.14431H14H13ZM12.3719 4.66057L11.6648 3.95346L11.6648 3.95346L12.3719 4.66057ZM5.16971 11.8628L5.43283 12.8276C5.60073 12.7818 5.75376 12.693 5.87682 12.5699L5.16971 11.8628ZM1 13L0.0352364 12.7369C-0.0591854 13.0831 0.0391427 13.4534 0.292893 13.7071C0.546642 13.9609 0.916904 14.0592 1.26312 13.9648L1 13ZM2.13719 8.8303L1.43009 8.12319C1.30703 8.24625 1.21822 8.39929 1.17243 8.56718L2.13719 8.8303ZM10.0465 2.33516C10.1528 2.2289 10.2789 2.14461 10.4178 2.08711L9.65241 0.239346C9.27093 0.397362 8.9243 0.62897 8.63232 0.920947L10.0465 2.33516ZM10.4178 2.08711C10.5566 2.0296 10.7054 2 10.8557 2V0C10.4428 0 10.0339 0.0813298 9.65241 0.239346L10.4178 2.08711ZM10.8557 2C11.006 2 11.1548 2.0296 11.2936 2.08711L12.059 0.239346C11.6775 0.0813296 11.2686 0 10.8557 0V2ZM11.2936 2.08711C11.4324 2.14461 11.5586 2.2289 11.6648 2.33516L13.0791 0.920947C12.7871 0.628971 12.4404 0.397363 12.059 0.239346L11.2936 2.08711ZM11.6648 2.33516C11.7711 2.44142 11.8554 2.56757 11.9129 2.7064L13.7607 1.94103C13.6026 1.55955 13.371 1.21292 13.0791 0.920947L11.6648 2.33516ZM11.9129 2.7064C11.9704 2.84523 12 2.99403 12 3.14431H14C14 2.7314 13.9187 2.32252 13.7607 1.94103L11.9129 2.7064ZM12 3.14431C12 3.29459 11.9704 3.44339 11.9129 3.58222L13.7607 4.34759C13.9187 3.9661 14 3.55722 14 3.14431H12ZM11.9129 3.58222C11.8554 3.72105 11.7711 3.8472 11.6648 3.95346L13.0791 5.36768C13.371 5.0757 13.6026 4.72907 13.7607 4.34759L11.9129 3.58222ZM11.6648 3.95346L4.46261 11.1557L5.87682 12.5699L13.0791 5.36767L11.6648 3.95346ZM4.9066 10.898L0.736884 12.0352L1.26312 13.9648L5.43283 12.8276L4.9066 10.898ZM1.96476 13.2631L3.10196 9.09342L1.17243 8.56718L0.0352364 12.7369L1.96476 13.2631ZM2.8443 9.53741L10.0465 2.33516L8.63232 0.920948L1.43009 8.12319L2.8443 9.53741ZM7 4L10 7L11.4142 5.58579L8.41421 2.58579L7 4Z"
          fill="#8E9CBB"
        />
      </svg>

      <svg
        v-if="icon === 'phone'"
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.9996 11.4147V9.60818C13.007 9.31287 12.9053 9.02516 12.714 8.79978C12.5226 8.5744 11.9619 8.3858 11.9619 8.3858L10.7731 8.11482C10.7731 8.11482 10.3224 8.01627 10.0968 8.0643C9.87116 8.11232 9.66405 8.2239 9.5 8.3858L8.50666 9.15054C6.99613 8.29333 5.85891 7.00754 5 5.5L5.85755 4.49841C6.01977 4.33469 6.13157 4.12799 6.17969 3.9028C6.22781 3.67761 6.12906 3.22785 6.12906 3.22785L5.70671 2.03578C5.70671 2.03578 5.52072 1.48178 5.2987 1.29122C5.07668 1.10067 4.79281 0.997182 4.5 1.00006H2.20558C2.03805 1.00022 1.87239 1.03519 1.71915 1.10274C1.5659 1.1703 1.42843 1.26896 1.31548 1.39244C1.20254 1.51592 1.11659 1.66153 1.06312 1.81998C1.00965 1.97843 0.98982 2.14625 1.0049 2.31277C1.06312 8.3858 5.85755 12.9365 11.6843 12.9951C11.8517 13.0102 12.0203 12.9903 12.1795 12.9365C12.3387 12.8828 12.4849 12.7965 12.6087 12.6831C12.7325 12.5697 12.8313 12.4318 12.8986 12.2781C12.9659 12.1245 13.0003 11.5824 12.9996 11.4147Z"
          stroke="#8E9CBB"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <svg
        v-if="icon === 'checklist'"
        width="14"
        height="13"
        viewBox="0 0 14 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 2H13M8 7H13M8 12H13M1 12L4 12M4 1L1.99999 3L1 2M4 6L1.99999 8L1 7"
          stroke="#8E9CBB"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <svg
        v-if="icon === 'excel'"
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.47538 3.125H10.5823L8.05679 6.85381L10.9062 11H8.71957L6.98437 8.43767L5.24813 11H3.0625L5.91196 6.85381L3.38642 3.125H5.49336L6.98437 5.29456L8.47538 3.125Z"
        />
        <path d="M1 13V1H13V13H1Z" stroke-width="2" />
      </svg>

      <svg
        v-if="icon === 'google'"
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="white"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M1 5H13M1 9H13M7 13V1M1 1V13H13V1H1Z" stroke="#12C971" stroke-width="2" fill="white" />
      </svg>

      <svg v-if="icon === 'print'" width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
        <path class="_stroke" d="M4 5V1H10.0625V5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path
          class="_stroke"
          d="M3.4 11H2.2C1.88174 11 1.57652 10.8595 1.35147 10.6095C1.12643 10.3594 1 10.0203 1 9.66667V6.33333C1 5.97971 1.12643 5.64057 1.35147 5.39052C1.57652 5.14048 1.88174 5 2.2 5H11.8C12.1183 5 12.4235 5.14048 12.6485 5.39052C12.8736 5.64057 13 5.97971 13 6.33333V9.66667C13 10.0203 12.8736 10.3594 12.6485 10.6095C12.4235 10.8595 12.1183 11 11.8 11H10.6"
          stroke="#8E9CBB"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path class="_stroke" d="M10 9H4V13H10V9Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>

      <svg v-if="icon === 'trash'" width="13" height="15" viewBox="0 0 13 15" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M1 3C0.447715 3 0 3.44772 0 4C0 4.55228 0.447715 5 1 5V3ZM12 5C12.5523 5 13 4.55228 13 4C13 3.44772 12.5523 3 12 3V5ZM2.92846 3.6C2.92846 4.15228 3.37618 4.6 3.92846 4.6C4.48075 4.6 4.92846 4.15228 4.92846 3.6H2.92846ZM5.21418 1V0V1ZM7.78561 1V0V1ZM8.07132 3.6C8.07132 4.15228 8.51903 4.6 9.07132 4.6C9.6236 4.6 10.0713 4.15228 10.0713 3.6H8.07132ZM6 7C6 6.44772 5.55228 6 5 6C4.44772 6 4 6.44772 4 7H6ZM4 11C4 11.5523 4.44772 12 5 12C5.55228 12 6 11.5523 6 11H4ZM9 7C9 6.44772 8.55228 6 8 6C7.44772 6 7 6.44772 7 7H9ZM7 11C7 11.5523 7.44772 12 8 12C8.55228 12 9 11.5523 9 11H7ZM1 5H12V3H1V5ZM4.92846 3.6V2.3H2.92846V3.6H4.92846ZM4.92846 2.3C4.92846 2.21689 4.96122 2.13938 5.01604 2.08395L3.59404 0.677572C3.16663 1.10973 2.92846 1.69355 2.92846 2.3H4.92846ZM5.01604 2.08395C5.0705 2.02889 5.14199 2 5.21418 2V0C4.60438 0 4.02182 0.245036 3.59404 0.677572L5.01604 2.08395ZM5.21418 2H7.78561V0H5.21418V2ZM7.78561 2C7.85779 2 7.92929 2.02889 7.98374 2.08395L9.40575 0.677572C8.97796 0.245036 8.3954 0 7.78561 0V2ZM7.98374 2.08395C8.03856 2.13938 8.07132 2.21689 8.07132 2.3H10.0713C10.0713 1.69355 9.83316 1.10973 9.40575 0.677572L7.98374 2.08395ZM8.07132 2.3V3.6H10.0713V2.3H8.07132ZM4 7V11H6V7H4ZM7 7V11H9V7H7ZM10 4V12H12V4H10ZM9 13H4V15H9V13ZM3 12V4H1V12H3ZM4 13C3.44772 13 3 12.5523 3 12H1C1 13.6569 2.34315 15 4 15V13ZM10 12C10 12.5523 9.55228 13 9 13V15C10.6569 15 12 13.6569 12 12H10Z"
        />
      </svg>

      <svg
        v-if="icon === 'profile-warning'"
        width="15"
        height="17"
        viewBox="0 0 15 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 4V3H0V4H1ZM1 16H0V17H1V16ZM11 16V17H12V16H11ZM11 4H12V3H11V4ZM5 10C5 10.5523 5.44772 11 6 11C6.55228 11 7 10.5523 7 10H5ZM7 7C7 6.44772 6.55228 6 6 6C5.44772 6 5 6.44772 5 7H7ZM0 4V16H2V4H0ZM1 17H11V15H1V17ZM10 4V16H12V4H10ZM1 5H11V3H1V5ZM7 10V7H5V10H7Z"
        />
        <path class="_stroke" d="M4 4.5V1H14V13H11" stroke="#FFB800" stroke-width="2" />
        <circle cx="6" cy="13" r="1" />
      </svg>

      <svg v-if="icon === 'plus'" width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M6.99884 14C7.55112 14 7.99884 13.5498 7.99884 12.9944L7.99987 1.00559C7.99987 0.45022 7.55216 0 6.99987 0C6.44759 0 5.99987 0.45022 5.99987 1.0056L5.99884 12.9944C5.99884 13.5498 6.44655 14 6.99884 14Z"
        />
        <path
          d="M-4.673e-05 6.96083C-4.673e-05 6.40545 0.447668 5.95523 0.999953 5.95523L13 5.95524C13.5523 5.95524 14 6.40546 14 6.96084C14 7.51621 13.5523 7.96643 13 7.96643L0.999953 7.96642C0.447668 7.96642 -4.673e-05 7.5162 -4.673e-05 6.96083Z"
        />
      </svg>

      <svg
        v-if="icon === 'constructor'"
        width="12"
        height="10"
        viewBox="0 0 12 10"
        fill="#000000"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 1H11M1 5H6M1 9H11"
          stroke="#8E9CBB"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <svg
        v-if="icon === 'positioning'"
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.69594 15.7086C8.30473 16.0991 7.67045 16.0991 7.27924 15.7086L5.29341 13.7296C4.9022 13.339 4.9022 12.7059 5.29341 12.3153C5.68462 11.9248 6.3189 11.9248 6.71011 12.3153L8.69594 14.2944C9.08715 14.6849 9.08716 15.318 8.69594 15.7086Z"
        />
        <path
          d="M7.30385 15.7086C7.69506 16.0991 8.32934 16.0991 8.72055 15.7086L10.7066 13.7296C11.0978 13.339 11.0978 12.7059 10.7066 12.3153C10.3154 11.9248 9.6811 11.9248 9.28989 12.3153L7.30385 14.2944C6.91263 14.6849 6.91263 15.318 7.30385 15.7086Z"
        />
        <path
          d="M7.98759 15.0157C7.43433 15.0157 6.98583 14.5679 6.98583 14.0157V3C6.98583 2.44772 7.43433 2 7.98759 2C8.54085 2 8.98935 2.44772 8.98935 3V14.0157C8.98935 14.5679 8.54085 15.0157 7.98759 15.0157Z"
        />
        <path
          d="M8.69594 0.292893C8.30473 -0.0976311 7.67045 -0.0976311 7.27924 0.292893L5.29341 2.27191C4.9022 2.66243 4.9022 3.2956 5.29341 3.68612C5.68462 4.07664 6.3189 4.07664 6.71011 3.68612L8.69594 1.70711C9.08715 1.31658 9.08716 0.683417 8.69594 0.292893Z"
        />
        <path
          d="M7.30385 0.292893C7.69506 -0.0976311 8.32934 -0.0976311 8.72055 0.292893L10.7066 2.27191C11.0978 2.66243 11.0978 3.2956 10.7066 3.68612C10.3154 4.07664 9.6811 4.07664 9.28989 3.68612L7.30385 1.70711C6.91263 1.31658 6.91263 0.683417 7.30385 0.292893Z"
        />
        <path
          d="M15.7086 7.30406C16.0991 7.69527 16.0991 8.32955 15.7086 8.72076L13.7296 10.7066C13.339 11.0978 12.7059 11.0978 12.3153 10.7066C11.9248 10.3154 11.9248 9.6811 12.3153 9.28989L14.2944 7.30406C14.6849 6.91285 15.318 6.91285 15.7086 7.30406Z"
        />
        <path
          d="M15.7086 8.69615C16.0991 8.30494 16.0991 7.67066 15.7086 7.27945L13.7296 5.29341C13.339 4.9022 12.7059 4.9022 12.3153 5.29341C11.9248 5.68462 11.9248 6.3189 12.3153 6.71011L14.2944 8.69615C14.6849 9.08737 15.318 9.08737 15.7086 8.69615Z"
        />
        <path
          d="M15.0157 8.01241C15.0157 8.56567 14.5679 9.01417 14.0157 9.01417H3C2.44772 9.01417 2 8.56567 2 8.01241C2 7.45915 2.44772 7.01065 3 7.01065H14.0157C14.5679 7.01065 15.0157 7.45915 15.0157 8.01241Z"
        />
        <path
          d="M0.292893 7.30406C-0.0976311 7.69527 -0.0976311 8.32955 0.292893 8.72076L2.27191 10.7066C2.66243 11.0978 3.2956 11.0978 3.68612 10.7066C4.07664 10.3154 4.07664 9.6811 3.68612 9.28989L1.70711 7.30406C1.31658 6.91285 0.683417 6.91285 0.292893 7.30406Z"
        />
        <path
          d="M0.292893 8.69615C-0.0976311 8.30494 -0.0976311 7.67066 0.292893 7.27945L2.27191 5.29341C2.66243 4.9022 3.2956 4.9022 3.68612 5.29341C4.07664 5.68462 4.07664 6.3189 3.68612 6.71011L1.70711 8.69615C1.31658 9.08737 0.683417 9.08737 0.292893 8.69615Z"
        />
      </svg>

      <svg
        v-if="icon === 'arrow'"
        width="12"
        height="7"
        viewBox="0 0 12 7"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.30964 6.70905C4.92189 6.32111 4.92189 5.69215 5.30964 5.30421L10.305 0.306472C10.6928 -0.0814626 11.3214 -0.081462 11.7092 0.306473C12.0969 0.694408 12.0969 1.32337 11.7092 1.71131L6.71381 6.70905C6.32606 7.09698 5.69739 7.09698 5.30964 6.70905Z"
          fill="#8E9CBB"
        />
        <path
          d="M6.70587 6.70905C7.09363 6.32111 7.09363 5.69215 6.70587 5.30421L1.69498 0.290951C1.30723 -0.096984 0.678565 -0.0969834 0.290814 0.290951C-0.0969378 0.678886 -0.0969378 1.30785 0.290814 1.69579L5.3017 6.70905C5.68946 7.09698 6.31812 7.09698 6.70587 6.70905Z"
          fill="#8E9CBB"
        />
      </svg>

      <svg
        v-if="icon === 'filter-column'"
        width="16"
        height="14"
        viewBox="0 0 16 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          class="_stroke"
          d="M13.392 2.24794L14.0338 1.4375H13H3H1.96365L2.60864 2.24868L6.51562 7.16237V10.9375V11.2454L6.79061 11.384L8.77499 12.384L9.5 12.7494V11.9375V7.16184L13.392 2.24794Z"
          stroke="#8E9CBB"
          stroke-linecap="round"
        />
      </svg>

      <svg
        v-if="icon === 'filter'"
        width="13"
        height="12"
        viewBox="0 0 13 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 1L12.7855 1.61885C13.0226 1.31795 13.0669 0.908077 12.8997 0.563449C12.7325 0.21882 12.3831 0 12 0V1ZM1 1V0C0.616259 0 0.266364 0.219593 0.0994958 0.565153C-0.0673727 0.910712 -0.0217795 1.32128 0.216836 1.62182L1 1ZM5.01983 6.06289H6.01983C6.01983 5.83708 5.9434 5.61792 5.80299 5.44108L5.01983 6.06289ZM5.01983 10.0252H4.01983C4.01983 10.4581 4.29839 10.8418 4.70999 10.9759L5.01983 10.0252ZM8.01133 11L7.7015 11.9508C8.00599 12.05 8.33959 11.9974 8.59877 11.8093C8.85794 11.6211 9.01133 11.3203 9.01133 11H8.01133ZM8.01133 6.06289L7.22582 5.44405C7.08688 5.6204 7.01133 5.83838 7.01133 6.06289H8.01133ZM12 0H1V2H12V0ZM0.216836 1.62182L4.23667 6.68471L5.80299 5.44108L1.78316 0.378185L0.216836 1.62182ZM4.01983 6.06289V10.0252H6.01983V6.06289H4.01983ZM4.70999 10.9759L7.7015 11.9508L8.32117 10.0492L5.32966 9.07437L4.70999 10.9759ZM9.01133 11V6.06289H7.01133V11H9.01133ZM8.79684 6.68174L12.7855 1.61885L11.2145 0.381154L7.22582 5.44405L8.79684 6.68174Z"
          fill="#8E9CBB"
        />
      </svg>

      <svg v-if="icon === 'filter-drop'" width="16" height="12" viewBox="0 0 16 12" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12 1L12.7855 1.61885C13.0226 1.31795 13.0669 0.908077 12.8997 0.563449C12.7325 0.21882 12.3831 0 12 0V1ZM1 1V0C0.616259 0 0.266364 0.219593 0.0994958 0.565153C-0.0673727 0.910712 -0.0217795 1.32128 0.216836 1.62182L1 1ZM5.01983 6.06289H6.01983C6.01983 5.83708 5.9434 5.61792 5.80299 5.44108L5.01983 6.06289ZM5.01983 10.0252H4.01983C4.01983 10.4581 4.29839 10.8418 4.70999 10.9759L5.01983 10.0252ZM8.01133 11L7.7015 11.9508C8.00599 12.05 8.33959 11.9974 8.59877 11.8093C8.85794 11.6211 9.01133 11.3203 9.01133 11H8.01133ZM8.01133 6.06289L7.22582 5.44405C7.08688 5.6204 7.01133 5.83838 7.01133 6.06289H8.01133ZM14.7624 7.77686C15.1569 7.39038 15.1634 6.75725 14.7769 6.36272C14.3905 5.96819 13.7573 5.96166 13.3628 6.34814L14.7624 7.77686ZM10.3003 9.34814C9.90577 9.73462 9.89924 10.3678 10.2857 10.7623C10.6722 11.1568 11.3053 11.1633 11.6999 10.7769L10.3003 9.34814ZM11.66 6.34776C11.2609 5.966 10.6279 5.98005 10.2461 6.37915C9.86436 6.77825 9.87842 7.41126 10.2775 7.79302L11.66 6.34776ZM13.34 10.7225C13.7391 11.1042 14.3721 11.0902 14.7539 10.6911C15.1356 10.292 15.1216 9.65896 14.7225 9.2772L13.34 10.7225ZM12 0H1V2H12V0ZM0.216836 1.62182L4.23667 6.68471L5.80299 5.44108L1.78316 0.378185L0.216836 1.62182ZM4.01983 6.06289V10.0252H6.01983V6.06289H4.01983ZM4.70999 10.9759L7.7015 11.9508L8.32117 10.0492L5.32966 9.07437L4.70999 10.9759ZM9.01133 11V6.06289H7.01133V11H9.01133ZM8.79684 6.68174L12.7855 1.61885L11.2145 0.381154L7.22582 5.44405L8.79684 6.68174ZM13.3628 6.34814L11.8302 7.84944L13.2298 9.27816L14.7624 7.77686L13.3628 6.34814ZM11.8302 7.84944L10.3003 9.34814L11.6999 10.7769L13.2298 9.27816L11.8302 7.84944ZM10.2775 7.79302L11.8388 9.28643L13.2212 7.84117L11.66 6.34776L10.2775 7.79302ZM11.8388 9.28643L13.34 10.7225L14.7225 9.2772L13.2212 7.84117L11.8388 9.28643Z"
        />
      </svg>

      <svg v-if="icon === 'cog'" width="17" height="16" viewBox="0 0 17 16" xmlns="http://www.w3.org/2000/svg">
        <path
          class="_stroke"
          d="M8.5686 9.90909C9.62297 9.90909 10.4777 9.05436 10.4777 8C10.4777 6.94564 9.62297 6.09091 8.5686 6.09091C7.51424 6.09091 6.65951 6.94564 6.65951 8C6.65951 9.05436 7.51424 9.90909 8.5686 9.90909Z"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          class="_stroke"
          d="M13.2777 9.90909C13.193 10.101 13.1677 10.3139 13.2051 10.5204C13.2426 10.7268 13.341 10.9173 13.4877 11.0673L13.5259 11.1055C13.6442 11.2237 13.7381 11.364 13.8021 11.5185C13.8662 11.673 13.8991 11.8387 13.8991 12.0059C13.8991 12.1732 13.8662 12.3388 13.8021 12.4933C13.7381 12.6478 13.6442 12.7882 13.5259 12.9064C13.4077 13.0247 13.2673 13.1186 13.1128 13.1826C12.9583 13.2467 12.7927 13.2796 12.6254 13.2796C12.4582 13.2796 12.2926 13.2467 12.138 13.1826C11.9835 13.1186 11.8432 13.0247 11.725 12.9064L11.6868 12.8682C11.5368 12.7215 11.3463 12.6231 11.1399 12.5856C10.9335 12.5482 10.7205 12.5735 10.5286 12.6582C10.3404 12.7388 10.1799 12.8728 10.0668 13.0435C9.95373 13.2143 9.89306 13.4143 9.89224 13.6191V13.7273C9.89224 14.0648 9.75815 14.3885 9.51947 14.6272C9.28078 14.8659 8.95706 15 8.61951 15C8.28196 15 7.95824 14.8659 7.71956 14.6272C7.48088 14.3885 7.34679 14.0648 7.34679 13.7273V13.67C7.34186 13.4594 7.27368 13.2551 7.15111 13.0837C7.02854 12.9123 6.85725 12.7818 6.65951 12.7091C6.46758 12.6244 6.25466 12.5991 6.04823 12.6365C5.8418 12.674 5.65131 12.7724 5.50133 12.9191L5.46315 12.9573C5.34495 13.0756 5.20458 13.1695 5.05007 13.2335C4.89557 13.2976 4.72995 13.3305 4.56269 13.3305C4.39544 13.3305 4.22982 13.2976 4.07532 13.2335C3.92081 13.1695 3.78044 13.0756 3.66224 12.9573C3.54391 12.8391 3.45003 12.6987 3.38598 12.5442C3.32193 12.3897 3.28897 12.2241 3.28897 12.0568C3.28897 11.8896 3.32193 11.7239 3.38598 11.5694C3.45003 11.4149 3.54391 11.2746 3.66224 11.1564L3.70042 11.1182C3.84713 10.9682 3.94554 10.7777 3.98297 10.5713C4.0204 10.3649 3.99513 10.1519 3.91042 9.96C3.82975 9.77178 3.69581 9.61126 3.52508 9.4982C3.35435 9.38513 3.15429 9.32445 2.94951 9.32364H2.84133C2.50378 9.32364 2.18006 9.18955 1.94138 8.95086C1.70269 8.71218 1.5686 8.38846 1.5686 8.05091C1.5686 7.71336 1.70269 7.38964 1.94138 7.15096C2.18006 6.91227 2.50378 6.77818 2.84133 6.77818H2.8986C3.10924 6.77325 3.31352 6.70508 3.48488 6.58251C3.65625 6.45994 3.78679 6.28865 3.85951 6.09091C3.94422 5.89897 3.96949 5.68606 3.93206 5.47963C3.89463 5.27319 3.79622 5.0827 3.64951 4.93273L3.61133 4.89455C3.493 4.77634 3.39912 4.63598 3.33507 4.48147C3.27102 4.32696 3.23806 4.16135 3.23806 3.99409C3.23806 3.82683 3.27102 3.66122 3.33507 3.50671C3.39912 3.35221 3.493 3.21184 3.61133 3.09364C3.72953 2.9753 3.8699 2.88143 4.02441 2.81738C4.17891 2.75333 4.34453 2.72036 4.51179 2.72036C4.67904 2.72036 4.84466 2.75333 4.99916 2.81738C5.15367 2.88143 5.29404 2.9753 5.41224 3.09364L5.45042 3.13182C5.6004 3.27852 5.79089 3.37694 5.99732 3.41437C6.20375 3.4518 6.41667 3.42653 6.6086 3.34182H6.65951C6.84773 3.26115 7.00825 3.12721 7.12132 2.95648C7.23438 2.78575 7.29506 2.58568 7.29588 2.38091V2.27273C7.29588 1.93518 7.42997 1.61146 7.66865 1.37277C7.90733 1.13409 8.23106 1 8.5686 1C8.90615 1 9.22987 1.13409 9.46856 1.37277C9.70724 1.61146 9.84133 1.93518 9.84133 2.27273V2.33C9.84215 2.53477 9.90282 2.73484 10.0159 2.90557C10.129 3.0763 10.2895 3.21024 10.4777 3.29091C10.6696 3.37562 10.8825 3.40089 11.089 3.36346C11.2954 3.32603 11.4859 3.22761 11.6359 3.08091L11.6741 3.04273C11.7923 2.92439 11.9326 2.83052 12.0871 2.76647C12.2416 2.70242 12.4073 2.66945 12.5745 2.66945C12.7418 2.66945 12.9074 2.70242 13.0619 2.76647C13.2164 2.83052 13.3568 2.92439 13.475 3.04273C13.5933 3.16093 13.6872 3.3013 13.7512 3.4558C13.8153 3.61031 13.8482 3.77593 13.8482 3.94318C13.8482 4.11044 13.8153 4.27605 13.7512 4.43056C13.6872 4.58507 13.5933 4.72543 13.475 4.84364L13.4368 4.88182C13.2901 5.0318 13.1917 5.22228 13.1542 5.42872C13.1168 5.63515 13.1421 5.84806 13.2268 6.04V6.09091C13.3075 6.27913 13.4414 6.43965 13.6121 6.55271C13.7829 6.66578 13.9829 6.72646 14.1877 6.72727H14.2959C14.6334 6.72727 14.9571 6.86136 15.1958 7.10005C15.4345 7.33873 15.5686 7.66245 15.5686 8C15.5686 8.33755 15.4345 8.66127 15.1958 8.89995C14.9571 9.13864 14.6334 9.27273 14.2959 9.27273H14.2386C14.0338 9.27354 13.8338 9.33422 13.663 9.44729C13.4923 9.56035 13.3584 9.72087 13.2777 9.90909Z"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <svg v-if="icon === 'bookmark'" width="12" height="15" viewBox="0 0 12 15" xmlns="http://www.w3.org/2000/svg">
        <path
          class="_stroke"
          d="M11 13.8571L6 10.2857L1 13.8571V2.42857C1 2.04969 1.15051 1.68633 1.41842 1.41842C1.68633 1.15051 2.04969 1 2.42857 1H9.57143C9.95031 1 10.3137 1.15051 10.5816 1.41842C10.8495 1.68633 11 2.04969 11 2.42857V13.8571Z"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <svg
        v-if="icon === 'info'"
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="7" cy="7" r="6.5" fill="white" stroke="#D3D8DF" />
        <circle r="1" transform="matrix(1 0 0 -1 7 4)" fill="#0066FF" />
        <rect width="2" height="5" rx="1" transform="matrix(1 0 0 -1 6 11)" fill="#0066FF" />
      </svg>

      <svg
        v-if="icon === 'notice'"
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="7" cy="7" r="6.5" fill="white" stroke="#FF238D" />
        <circle cx="7" cy="10" r="1" fill="#FF238D" />
        <rect x="6" y="3" width="2" height="5" rx="1" fill="#FF238D" />
      </svg>

      <svg v-if="icon === 'check'" width="14" height="10" viewBox="0 0 14 10" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M4.47288 9.52727C4.08236 9.13675 4.08236 8.50358 4.47288 8.11306L12.2929 0.292893C12.6835 -0.0976309 13.3166 -0.0976312 13.7072 0.292893C14.0977 0.683417 14.0977 1.31658 13.7072 1.70711L5.8871 9.52727C5.49657 9.91779 4.86341 9.91779 4.47288 9.52727Z"
        />
        <path
          d="M5.8871 9.52727C6.27762 9.13675 6.27756 8.50358 5.88704 8.11306L1.70711 3.93315C1.31658 3.54263 0.683417 3.54263 0.292893 3.93315C-0.097631 4.32368 -0.0976311 4.95684 0.292893 5.34737L4.47288 9.52727C4.86341 9.91779 5.49657 9.91779 5.8871 9.52727Z"
        />
      </svg>

      <svg
        v-if="icon === 'close'"
        width="13"
        height="13"
        viewBox="0 0 13 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.525425 11.6783C0.94995 12.1016 1.63824 12.1016 2.06277 11.6783L11.8886 1.88173C12.3132 1.45841 12.3132 0.772068 11.8886 0.348743C11.4641 -0.0745802 10.7758 -0.0745802 10.3513 0.348743L0.525425 10.1453C0.100901 10.5686 0.100901 11.255 0.525425 11.6783Z"
          fill="#FF238D"
        />
        <path
          d="M0.593335 0.450393C1.01786 0.0270681 1.70615 0.0270681 2.13068 0.450393L11.8886 10.1808C12.3132 10.6041 12.3132 11.2904 11.8886 11.7138C11.4641 12.1371 10.7758 12.1371 10.3513 11.7138L0.593335 1.98338C0.168811 1.56006 0.168811 0.873716 0.593335 0.450393Z"
          fill="#FF238D"
        />
      </svg>

      <svg v-if="icon === 'share'" width="14" height="16" viewBox="0 0 14 16" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12 3C12 3.55228 11.5523 4 11 4V6C12.6569 6 14 4.65685 14 3H12ZM11 4C10.4477 4 10 3.55228 10 3H8C8 4.65685 9.34315 6 11 6V4ZM10 3C10 2.44772 10.4477 2 11 2V0C9.34315 0 8 1.34315 8 3H10ZM11 2C11.5523 2 12 2.44772 12 3H14C14 1.34315 12.6569 0 11 0V2ZM14 13C14 11.3431 12.6569 10 11 10V12C11.5523 12 12 12.4477 12 13H14ZM11 10C9.34315 10 8 11.3431 8 13H10C10 12.4477 10.4477 12 11 12V10ZM8 13C8 14.6569 9.34315 16 11 16V14C10.4477 14 10 13.5523 10 13H8ZM11 16C12.6569 16 14 14.6569 14 13H12C12 13.5523 11.5523 14 11 14V16ZM4 8C4 8.55228 3.55228 9 3 9V11C4.65685 11 6 9.65685 6 8H4ZM3 9C2.44772 9 2 8.55228 2 8H0C0 9.65685 1.34315 11 3 11V9ZM2 8C2 7.44772 2.44772 7 3 7V5C1.34315 5 0 6.34315 0 8H2ZM3 7C3.55228 7 4 7.44772 4 8H6C6 6.34315 4.65685 5 3 5V7ZM8.94036 3.1237L4.251 6.10283L5.32346 7.79097L10.0128 4.81184L8.94036 3.1237ZM10.0128 11.2287L5.32346 8.24956L4.251 9.9377L8.94036 12.9168L10.0128 11.2287Z"
        />
      </svg>

      <svg v-if="icon === 'chart'" width="14" height="12" viewBox="0 0 14 12" xmlns="http://www.w3.org/2000/svg">
        <path class="_stroke" d="M1 1L1 11M5 5L5 11M9 3V11M13 7V11" stroke-width="2" stroke-linecap="round" />
      </svg>

      <svg
        v-if="icon === 'success'"
        width="14"
        height="10"
        viewBox="0 0 14 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.47288 9.68401C4.08236 9.29348 4.08236 8.66032 4.47288 8.2698L12.2929 0.449632C12.6835 0.0591074 13.3166 0.059107 13.7072 0.449631C14.0977 0.840156 14.0977 1.47332 13.7072 1.86384L5.8871 9.68401C5.49657 10.0745 4.86341 10.0745 4.47288 9.68401Z"
          fill="#12C971"
        />
        <path
          d="M5.8871 9.68401C6.27762 9.29348 6.27756 8.66032 5.88704 8.2698L1.70711 4.08989C1.31658 3.69937 0.683417 3.69937 0.292893 4.08989C-0.097631 4.48042 -0.0976311 5.11358 0.292893 5.50411L4.47288 9.68401C4.86341 10.0745 5.49657 10.0745 5.8871 9.68401Z"
          fill="#12C971"
        />
      </svg>
    </div>
  </div>
</template>

<script>
import calendarIcon from "@/assets/images/calendar-icon.svg";
import linkIcon from "@/assets/images/link-icon.svg";

export default {
  name: "c-icon",

  props: ["icon", "color"],

  data() {
    return {
      colorLocal: this.color,
      calendarIcon,
      linkIcon,
    };
  },

  watch: {
    color(value) {
      this.colorLocal = value;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.c-icon {
  width: 20px;
  height: 20px;

  &__wrapper {
    width: 20px;
    height: 20px;
    position: relative;
  }

  img {
    margin-bottom: 5px;
  }

  svg {
    position: absolute;
    top: 50%;
    left: 50%;
  }

  ._stroke {
    stroke: $color-label;
    fill: none;
  }

  &_bookmark {
    margin-left: -6px;
    margin-top: -7px;

    &.c-icon {
      &_color {
        &_white {
          svg {
            path {
              stroke: white;
            }
          }
        }
      }
    }
  }

  &_excel {
    margin-left: -7px;
    margin-top: -7px;

    &.c-icon {
      &_color {
        &_green,
        &_success {
          svg {
            fill: none;

            path:nth-child(1) {
              fill: $color-green;
            }

            path:nth-child(2) {
              stroke: $color-green;
            }
          }
        }
      }
    }
  }

  &_google {
    margin-left: -7px;
    margin-top: -7px;

    &.c-icon {
      &_color {
        &_green,
        &_success {
          svg {
            fill: none;
          }
        }
      }
    }
  }

  &_print {
    margin-left: -7px;
    margin-top: -7px;
  }

  &_trash {
    margin-left: -6.4px;
    margin-top: -8px;

    &.c-icon {
      &_color {
        &_secondary,
        &_pink {
          svg {
            fill: $color-pink;
          }
        }
      }
    }
  }

  &_profile-warning {
    margin-left: -8px;
    margin-top: -9px;

    &.c-icon {
      &_color {
        &_yellow {
          svg {
            fill: $color-yellow;

            ._stroke {
              stroke: $color-yellow;
            }
          }
        }
      }
    }
  }

  &_plus {
    margin-left: -7px;
    margin-top: -7px;

    &.c-icon {
      &_color {
        &_green {
          svg {
            fill: $color-green;
          }
        }

        &_blue {
          svg {
            fill: $color-blue;
          }
        }

        &_white {
          svg {
            fill: white;
          }
        }
      }
    }
  }

  &_constructor {
    margin-left: -6px;
    margin-top: -5px;
  }

  &_positioning {
    margin-left: -8px;
    margin-top: -8px;
  }

  &_arrow {
    margin-left: -6px;
    margin-top: -3px;
  }

  &_filter-column {
    margin-left: -8px;
    margin-top: -7px;

    &.c-icon {
      &_color {
        &_blue {
          svg {
            ._stroke {
              stroke: $color-blue;
              fill: $color-blue;
            }
          }
        }
      }
    }
  }

  &_filter {
    margin-left: -6px;
    margin-top: -6px;
  }

  &_filter-drop {
    margin-left: -8px;
    margin-top: -6px;

    &.c-icon {
      &_color {
        &_secondary,
        &_pink {
          svg {
            fill: $color-pink;
          }
        }
      }
    }
  }

  &_cog {
    margin-left: -8px;
    margin-top: -8px;
  }

  &_info,
  &_notice {
    margin-left: -7px;
    margin-top: -7px;
  }

  &_check {
    margin-left: -7px;
    margin-top: -5px;

    &.c-icon {
      &_color {
        &_pink {
          svg {
            fill: $color-pink;
          }
        }

        &_green {
          svg {
            fill: $color-green;
          }
        }
      }
    }
  }

  &_close {
    margin-top: -6px;
    margin-left: -6px;

    &.c-icon {
      &_color {
        &_pink {
          svg {
            fill: $color-pink;
          }
        }

        &_green {
          svg {
            fill: $color-green;
          }
        }
      }
    }
  }

  &_share {
    margin-left: -7px;
    margin-top: -8px;
  }

  &_chart {
    margin-left: -7px;
    margin-top: -6px;

    &.c-icon {
      &_color {
        &_blue {
          svg {
            ._stroke {
              stroke: $color-blue;
            }
          }
        }

        &_default {
          svg {
            ._stroke {
              stroke: $color-label;
            }
          }
        }
      }
    }
  }
}
</style>
